export default __webpack_public_path__ + "static/media/pa_5.9ba3133e.mp3";